<template>
	<div class="mapClass_ul">
		<div ref="legend" class="legend" style="display: none;">
			<div class="legend-ui">
				<div class="legend-li" style="background-color: #00EF20;"></div>
				<div><b>自动避障</b></div>
			</div>
			<div class="legend-ui">
				<div class="legend-li" style="background-color: #FFA749;"></div>
				<div><b>向左避障</b></div>
			</div>
			<div class="legend-ui">
				<div class="legend-li" style="background-color: #8F4BFF;"></div>
				<div><b>向右避障</b></div>
			</div>
			<div class="legend-ui">
				<div class="legend-li" style="background-color: #FC2020;"></div>
				<div><b>关闭避障</b></div>
			</div>
		</div>
		<img :src="mapUrl" class="mapImg" @load="imgSuccess">
		<div id="aaa" ref="circle_id" class="mapPostion" v-show="ifDraw">
			<div ref="circle_bottom" class="circle_bottom animation"></div>
		</div>
	</div>
</template>

<script>
	import {
		positonInfo,
		getMapAndRouteByNumber
	} from '@/api/user'
	import {
		getItem
	} from '@/utils/auth'
	export default {
		data() {
			return {
				dialogClose: require('../../static/img/close.png'),
				robotSrc: require('../../static/img/xyRobot.png'),
				mapUrl: '',
				robotId: '',
				lineList: [],
				ifDraw: false,
				mFloorEntity: {}
			}
		},
		props: {
			position: {},
			posInfo: {}
		},
		mounted() {
			let that = this
			this.getPosDetail(that.position)
		},
		methods: {
			getPosDetail(res) {
				let that = this
				that.robotId = res.robotId
				positonInfo({
					robotId: res.robotId,
					userId: getItem('userInfo').staffId
				}).then(res => {
					that.mapUrl = res.data.address
					that.mFloorEntity = res.data
					let vDom = that.$refs.circle_bottom
					let mapImgDom = document.getElementsByClassName('mapClass_ul')[0]
					let vDomZoomW = document.documentElement.clientWidth * 0.6
					let vDomZoomH = document.documentElement.scrollHeight * 0.8
					mapImgDom.style.width = res.data.width + 'px'
					mapImgDom.style.height = res.data.height + 'px'
					mapImgDom.style.margin = "0 auto"
					if (Number(res.data.width) > Number(res.data.height)) {
						mapImgDom.style.zoom = vDomZoomW / Number(res.data.width)
					} else {
						mapImgDom.style.zoom = vDomZoomH / Number(res.data.height)
					}

					that.$refs.legend.style.zoom = 1 / (vDomZoomH / Number(res.data.height))

					if (Number(res.data.width) <= 900) {
						vDom.style.width = '20px'
						vDom.style.height = '20px'
					} else if (Number(res.data.width) <= 1400 && Number(res.data.width) > 900) {
						vDom.style.width = '30px'
						vDom.style.height = '30px'
					} else if (Number(res.data.width) <= 1900 && Number(res.data.width) > 1400) {
						vDom.style.width = '45px'
						vDom.style.height = '45px'
					} else if (Number(res.data.width) > 1900) {
						vDom.style.width = '50px'
						vDom.style.height = '50px'
					}
				})
			},
			imgSuccess() {
				let that = this
				that.ifDraw = true
			},
			closeMap() {
				this.$emit('closeRobot', true)
			},
			drawPointFun (rowInfo) {
				let mFloorEntity = this.mFloorEntity
				const mapX = Math.sqrt(Math.pow(rowInfo.x, 2));
				const mapOX = Math.sqrt(Math.pow(mFloorEntity.originX, 2));
				let ax = 0;
				if (rowInfo.x == 0) {
					ax = mapOX;
				} else if (rowInfo.x > 0) {
					ax = mapOX + mapX;
				} else if (rowInfo.x < 0) {
					ax = mapOX - mapX;
				}

				const mapH =  mFloorEntity.height * mFloorEntity.resolution;
				const mapY =  Math.sqrt(Math.pow(rowInfo.y, 2));
				const mapOy = Math.sqrt(Math.pow(mFloorEntity.originY, 2));
				let ay = 0;
				if (rowInfo.y == 0) {
					ay = mapY;
				} else if (rowInfo.y > 0) {
					ay = mapH - mapOy - mapY;
				} else if (rowInfo.y < 0) {
					ay = mapH - mapOy + mapY;
				}

				ax = Number(ax / mFloorEntity.resolution);
				ay = Number(ay / mFloorEntity.resolution);
				return [ax, ay]
			}
		},
		destroyed() {
			// 关闭
		},
		watch: {
			posInfo: {
				immediate: true,
				handler(newValue, oldValue) {
					let that = this
					that.$nextTick(() => {
						if (newValue.positon && that.robotId === newValue.robotId) {
							that.$refs.circle_bottom.style.left = that.position.robotType == '04' ? that.drawPointFun({
								x: Number(newValue.positon.split(',')[0]),
								y: Number(newValue.positon.split(',')[1])
							})[0] - Number(that.$refs.circle_bottom.style.width.substring(0, 2)) / 2 + 'px' : newValue.positon.split(',')[0]+'px'
							that.$refs.circle_bottom.style.top = that.position.robotType == '04' ? that.drawPointFun({
								x: Number(newValue.positon.split(',')[0]),
								y: Number(newValue.positon.split(',')[1])
							})[1] - Number(that.$refs.circle_bottom.style.width.substring(0, 2)) / 2 + 'px' : newValue.positon.split(',')[1]+'px'
							that.$refs.circle_id.style.opacity = '1'
						}
					})
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@keyframes icon {
		0% {
			transform: translate(0, 0)
		}

		50% {
			transform: translate(0px, -10px)
		}

		100% {
			transform: translate(0, 0)
		}
	}

	.legend {
		position: absolute;
		left: 0px;
		bottom: 0px;
		width: 105px;
		z-index: 99;
		font-size: 12px;
	}

	.legend-li {
		width: 40px;
		height: 6px;
	}

	.legend-ui {
		display: flex;
		justify-content:space-between;
		align-items: center;
		margin: 2px 0px 2px 6px;
	}

	.pointClass {
		width: 3px;
		height: 3px;
		background-color: black;
		border-radius: 50%;
		position: absolute;
	}

	.linesClass {
		position: absolute;
		height: 6px;
		// border-top: 2px solid red;
	}

	.mapClass_ul {
		position: relative;
	}

	.mapImg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
	}

	.mapClose {
		position: absolute;
		width: 30px;
		height: 30px;
		top: -15px;
		right: -15px;
		cursor: pointer;
	}

	.mapPostion {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		opacity: 0;

		.circle_bottom {
			background: #FF0000; 
			border-radius: 100%;
			width: 80px; 
			height: 80px; 
			filter: alpha(opacity=40);
			z-index: -100;
			box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.7);
			opacity: 0;
			position: absolute;
		}
		.animation {
			-webkit-animation: twinkling 2.1s infinite ease-in-out;
			animation: twinkling 2.1s infinite ease-in-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		.animation2 {
			-webkit-animation: twinkling 2.1s infinite ease-in-out;
			animation: twinkling 2.1s infinite ease-in-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		@-webkit-keyframes twinkling {
			0% {
				opacity: 0.8;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #FF0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}

			50% {
				opacity: 1;
				filter: alpha(opacity=50);
				-webkit-transform: scale(1.2); /* 保持1.2倍缩放 */
				background-color: #FF4444;
				box-shadow: 0px 0px 60px 30px rgba(255, 0, 0, 0.9); /* 阴影增大2倍 */
			}

			100% {
				opacity: 0.6;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #CC0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}
		}

		@keyframes twinkling {
			0% {
				opacity: 0.8;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #FF0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}

			50% {
				opacity: 1;
				filter: alpha(opacity=50);
				-webkit-transform: scale(1.2); /* 保持1.2倍缩放 */
				background-color: #FF4444;
				box-shadow: 0px 0px 60px 30px rgba(255, 0, 0, 0.9); /* 阴影增大2倍 */
			}

			100% {
				opacity: 0.6;
				filter: alpha(opacity=20);
				-webkit-transform: scale(1);
				background-color: #CC0000;
				box-shadow: 0px 0px 40px 20px rgba(255, 0, 0, 0.6);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/RobotMapInfo.vue